import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/points-dashboard')({
  beforeLoad: () => {
    const token = localStorage.getItem('token');
    if (!token) {
      throw redirect({ to: '/login' });
    }
    throw redirect({
      to: '/admin/store',
      search: { tab: 'points-overview' },
    });
  },
  component: () => null,
});
